import classNames from 'classnames';
import moment from 'moment';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { DateDisplayHelper } from '../../service/DateDisplayHelper/DateDisplayHelper';
import { TestBem } from '../../service/TestBem';

import './DateCell.css';

export interface Props {
    date: moment.Moment;
    showTime?: boolean;
    cls?: string; // TODO: костыль, https://st.yandex-team.ru/DIRECT-81353
}

export class DateCell extends React.PureComponent<Props> {
    render() {
        const { date, cls, showTime = true } = this.props,
            moscowDate = date.clone().utcOffset('+0300'),
            dateText = DateDisplayHelper.getDateText(moscowDate);

        return (
            <div className={classNames(cls, Bem.cls('date-cell'))}>
                <div className={Bem.cls('date-cell', 'date')}>{dateText}</div>
                {showTime ? (
                    <div
                        className={classNames(
                            Bem.cls('date-cell', 'time'),
                            TestBem.cls('date-cell', 'time')
                        )}
                    >
                        {moscowDate.format('HH:mm')}
                    </div>
                ) : null}
            </div>
        );
    }
}
